import { render } from "./LoginIdUy.vue?vue&type=template&id=c415af92"
import script from "./LoginIdUy.vue?vue&type=script&lang=js"
export * from "./LoginIdUy.vue?vue&type=script&lang=js"

import exportComponent from "/builds/aplicaciones_mides/pat_qr/QRreader/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__